import { render, staticRenderFns } from "./BookEditComponent.vue?vue&type=template&id=1a45f65f&scoped=true&"
import script from "./BookEditComponent.vue?vue&type=script&lang=ts&"
export * from "./BookEditComponent.vue?vue&type=script&lang=ts&"
import style0 from "./BookEditComponent.vue?vue&type=style&index=0&id=1a45f65f&prod&lang=scss&"
import style1 from "./BookEditComponent.vue?vue&type=style&index=1&id=1a45f65f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a45f65f",
  null
  
)

export default component.exports